import React from 'react';
import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { trackEvent } from '@99designs/tracking';
import ReviewCard from '../../../../shared/components/Card/ReviewCard';
import Heading from '../../../../shared/components/Heading';
import { ReviewSchema } from '../../../../shared/components/Schema';
import { avatarPath } from '../../../../shared/lib/platformUrls';
import { media, spaces } from '../../../../shared/lib/styles';
import { publicImageUrl } from '../../../lib/publicImageUrl';
import Grid from '../../Grid';
import Scroll from '../../Scroll';
import { CategoryConfig } from '../CategoryConfigProvider';
import Stats from './Stats';
import { reviewCards } from './reviewCards';

interface Props {
    category: Pick<CategoryConfig, 'key' | 'title'>;
}

const CardWrapper = styled.div`
    margin-right: ${spaces.gutter}px;

    @media ${media('small')} {
        margin-right: ${spaces.halfGutter}px;
    }

    &:last-child {
        margin-right: 0;
    }
`;

const Text = styled.p`
    margin-bottom: ${spaces.space10}px;
    width: 19em;

    @media ${media('small')} {
        width: 18em;
    }
`;

function ReviewsSection({ category }: Props) {
    return (
        <Box paddingY={['3bu', '3bu', '4bu', '6bu']}>
            <Grid>
                <Heading type="h2" variations={['h2']}>
                    {__('Our clients love us')}
                </Heading>
            </Grid>

            <Scroll gridWidth={1300} controlsEnabled={true}>
                <Box display="flex" paddingTop="0.5bu" marginBottom="4bu">
                    <Box
                        display="flex"
                        flexDirection="column"
                        marginRight={['2bu', '2bu', '4bu', '4bu']}
                    >
                        <Text>
                            {__(
                                'We’ve been the leader in logo design since 2008. But you don’t have to take our word for it…'
                            )}
                        </Text>
                        <Stats />
                    </Box>
                    {reviewCards.map((reviewCard, index) => (
                        <React.Fragment key={index}>
                            <ReviewSchema
                                review={reviewCard.clientReview.review}
                                ratingValue={reviewCard.clientReview.rating}
                                author={reviewCard.client.displayName}
                                categoryKey={category.key}
                            />
                            <CardWrapper key={index}>
                                <ReviewCard
                                    key={index}
                                    design={{
                                        url: publicImageUrl(reviewCard.design.url),
                                        alt: formatMessage(
                                            __("{categoryTitle} with the title '{imageTitle}'"),
                                            {
                                                categoryTitle: __(category.title),
                                                imageTitle: reviewCard.contest.title,
                                            }
                                        ),
                                        designerName: reviewCard.design.designerName,
                                    }}
                                    clientReview={{
                                        rating: reviewCard.clientReview.rating,
                                        review: reviewCard.clientReview.review,
                                    }}
                                    clientName={reviewCard.client.displayName}
                                    contest={reviewCard.contest}
                                    avatarUrl={avatarPath(reviewCard.client.id, 96)}
                                    onTabChange={(id) =>
                                        trackEvent('Clicked Tabbed Content Anchor', {
                                            category: category.key,
                                            content_id: id,
                                        })
                                    }
                                />
                            </CardWrapper>
                        </React.Fragment>
                    ))}
                </Box>
            </Scroll>
        </Box>
    );
}

export default ReviewsSection;
